export class SmeltingFurnaceMeasure {
    constructor({
        id= ``,
        day= '',
        time= ``,
        locId= ``,
        locName= ``,
        shift= ``,
        furnaceNumber= ``,
        rise1= ``,
        offset1= ``,
        rise2= ``,
        offset2= ``,
        rise3= ``,
        offset3= ``,
        rise4= ``,
        offset4= ``,
        rise5= ``,
        offset5= ``,
        rise6= ``,
        offset6= ``,
        rise7= ``,
        offset7= ``,
        rise8= ``,
        offset8= ``,
        rise9= ``,
        offset9= ``,
        rise10= ``,
        offset10= ``,
        rise11= ``,
        offset11= ``,
        rise12= ``,
        offset12= ``,
        principal= ``,
        remark= ``,
    }={}){
        this.id = id;
        this.day = day;
        this.time = time;
        this.locId = locId;
        this.locName = locName;
        this.shift = shift;
        this.furnaceNumber = furnaceNumber;
        this.rise1 = rise1;
        this.offset1 = offset1;
        this.rise2 = rise2;
        this.offset2 = offset2;
        this.rise3 = rise3;
        this.offset3 = offset3;
        this.rise4 = rise4;
        this.offset4 = offset4;
        this.rise5 = rise5;
        this.offset5 = offset5;
        this.rise6 = rise6;
        this.offset6 = offset6;
        this.rise7 = rise7;
        this.offset7 = offset7;
        this.rise8 = rise8;
        this.offset8 = offset8;
        this.rise9 = rise9;
        this.offset9 = offset9;
        this.rise10 = rise10;
        this.offset10 = offset10;
        this.rise11 = rise11;
        this.offset11 = offset11;
        this.rise12 = rise12;
        this.offset12 = offset12;
        this.principal = principal;
        this.remark = remark;
    }
}

export function gridFields() {
    return Object.freeze([ 
        {
            key: 'day',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'time',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
      },
        {
            key: 'locName',
            label: 'lbl.fm.locationName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'shift',
            label: 'lbl.shiftPlan.shiftName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise1',
            label: 'lbl.fm.rise1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset1',
            label: 'lbl.fm.offset1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise2',
            label: 'lbl.fm.rise2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset2',
            label: 'lbl.fm.offset2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise3',
            label: 'lbl.fm.rise3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset3',
            label: 'lbl.fm.offset3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise4',
            label: 'lbl.fm.rise4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset4',
            label: 'lbl.fm.offset4',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise5',
            label: 'lbl.fm.rise5',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset5',
            label: 'lbl.fm.offset5',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise6',
            label: 'lbl.fm.rise6',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset6',
            label: 'lbl.fm.offset6',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise7',
            label: 'lbl.fm.rise7',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset7',
            label: 'lbl.fm.offset7',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise8',
            label: 'lbl.fm.rise8',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset8',
            label: 'lbl.fm.offset8',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise9',
            label: 'lbl.fm.rise9',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset9',
            label: 'lbl.fm.offset9',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise10',
            label: 'lbl.fm.rise10',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset10',
            label: 'lbl.fm.offset10',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise11',
            label: 'lbl.fm.rise11',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset11',
            label: 'lbl.fm.offset11',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'rise12',
            label: 'lbl.fm.rise12',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'offset12',
            label: 'lbl.fm.offset12',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'principal',
            label: 'lbl.fm.principal',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'remark',
            label: 'lbl.fm.remark',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new SmeltingFurnaceMeasure()).map(i => 'entity.'+i));

export const filterFields = [
    'filter.locNameFilter',
    'filter.shiftFilter',
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceNumberFilter',
];

export const filter = {
    'locNameFilter' : "default",
    'shiftFilter' : "default",
    'startTimeFilter' : "",
    'endTimeFilter': "",
    'furnaceNumberFilter' : "default",
};